<template>
    <v-container
            class="fill-height"
            fluid
    >
        <v-row
                align="center"
                justify="end"
        >
            <v-col
                    cols="12"
                    sm="6"
                    md="5"
                    lg="3"
            >
                <v-card class="elevation-12">
                    <div style="height: 0.5rem;">
                        <v-progress-linear
                                v-show="loading"
                                height="8"
                                indeterminate
                                color="primary"
                        ></v-progress-linear>
                    </div>
                    <v-card-text>
                        <v-container class="pb-0">
                            <v-row class="header-image-container">
                                <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                >
                                    <v-img
                                            src="./../assets/logo.jpg"
                                            lazy-src="./../assets/logo.jpg"
                                            class="grey lighten-2"
                                            max-width="250"
                                    ></v-img>
                                </v-col>
                            </v-row>
                            <v-row v-if="!showOnlySso">
                                <v-col cols="12" sm="12" md="12">
                                    <v-alert v-show="this.errorMessageMicrosoft" type="error"
                                             transition="scale-transition">
                                        {{errorMessageMicrosoft}}
                                    </v-alert>
                                    <v-alert v-show="error" type="error"
                                             transition="scale-transition">
                                        {{error}}
                                    </v-alert>

                                    <v-alert v-show="success" type="success"
                                             transition="scale-transition">
                                        {{success}}
                                    </v-alert>

                                    <v-form @submit.prevent="submit">
                                        <v-text-field
                                                autofocus
                                                ref="username"
                                                :label="$t('common.username') + '*'"
                                                name="userName"
                                                type="text"
                                                v-model="user.userName"

                                                :error-messages="usernameErrors"
                                                @input="$v.user.userName.$touch()"
                                                @blur="$v.user.userName.$touch()"
                                        ></v-text-field>
                                   </v-form>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-container class="py-0">
                            <v-row v-if="!showOnlySso">
                                <v-col cols="12" sm="12" md="12">
                                    <v-btn x-large color="success" class="login-button" :disabled="loading"
                                           @click="submit">{{ $t("common.continue") }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <table style="width: 100%; margin: 20px 0;" v-if="!showOnlySso && showSso">
                                <tr>
                                    <td>
                                        <hr />
                                    </td>
                                    <td style="width: 50px;">{{ $t("common.or") }}</td>
                                    <td><hr /></td>
                                </tr>
                            </table>
                            <v-row v-if="showSso">
                                <v-col cols="12" sm="12" md="12">
                                    <v-btn x-large class="login-button ms-button" :disabled="loading"
                                           @click="loginWithMicrosoft">
                                        <span style="display: inline-block; padding-right: 15px;">
                                            <img width="24px" height="24px" src="./../assets/Microsoft_Logo_32px.png" />
                                        </span>
                                        {{ $t("common.continueWithMicrosoftAccount") }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import {required} from 'vuelidate/lib/validators'
    function resolveWebclientHash(){
      const currentHash = window.location.hash;
      const hashParts = currentHash.split('#');
      return hashParts.length > 2 ? `#${hashParts.slice(2).join('#')}` : '';
    }
    function readAuthFromLocalStorage(){
      const storage = window['localStorage'];
      if(!storage){
          return null
      }
      const authString = storage.getItem('auth');
      if(authString && authString.length > 0){
        return JSON.parse(authString);
      }
      return null;
    }
    export default {
        name: 'Login',

        validations: {
            user: {
                userName: {
                    required
                }
            }
        },

        data: () => ({
            error: null,
            errorMessageMicrosoft: null,
            success: null,
            loading: false,

            context: '',

            user: {
                userName: ''
            },
            showPassword: false,

            showOnlySso: false,
            showSso: true
        }),
        computed: {
            usernameErrors() {
                const errors = []

                if(!this.$v.user.userName.$dirty) {
                    return errors
                }

                !this.$v.user.userName.required && errors.push(this.$t('common.errors.fieldRequired'))
                return errors
            },
            passwordErrors() {
                const errors = [];

                if(!this.$v.user.password.$dirty) {
                    return errors
                }

                !this.$v.user.password.required && errors.push(this.$t('common.errors.fieldRequired'))

                return errors
            },
        },
        created() {
            // Check if VUE_APP_SSO_DOMAINS variable has been passed from environment
            const ssoOnlyDomains = process.env.VUE_APP_SSO_DOMAINS ? process.env.VUE_APP_SSO_DOMAINS.split(',') : [];

            // If the build is running on a domain listed in VUE_APP_SSO_DOMAINS we only want to show SSO as login possibility
            if(ssoOnlyDomains.length > 0) {
              this.showOnlySso = ssoOnlyDomains.includes(window.location.hostname);
            }

            if(this.$route.query.error !== undefined || location.search.includes('error')) {
              const errorCode = this.$route.query.error || new URLSearchParams(location.search).get('error');

              if(errorCode) {
                    this.errorMessageMicrosoft = this.$t('loginErrorMessages.' + errorCode);
                    // Drop cached auth in case of errors
                    window['localStorage'].removeItem('auth')
                  }
            }

            this.$store.dispatch('isLoggedIn').then((responseData) => {
                if(responseData.success === true && responseData.result !== false && responseData.result.user) {
                    this.forwardToSharesuite();
                } else{
                  // Redirect to oauth login if cached auth is present
                  const auth = readAuthFromLocalStorage()
                  if(auth && auth.authMethod === 'OAUTH_AZURE'){
                    const webclientHash = resolveWebclientHash();
                    const redirectUrl = location.protocol + "//" + location.hostname
                        + '/platform/web/v1/auth/oauth2/authorization/azure?login_hint=' + auth.user.username
                        + (webclientHash ? '&client_path='+webclientHash : '')
                    location.assign(redirectUrl);
                  }
                }
            });

            const email = this.$route.query.user;
            if(typeof email !== 'undefined') {
                this.user.userName = email;
            }
        },
        methods: {
            forwardToSharesuite() {
                let forwardHash = location.hash.substr(location.hash.lastIndexOf("#")).replace("#/login", "");
                let host = location.protocol + "//" + location.hostname + (!location.hostname.endsWith("/") ? "/" : "");
                location.replace(host + process.env.VUE_APP_WEB_APP_PATH + '?' + forwardHash);
            },
            loginWithMicrosoft() {
                let ms = location.protocol + "//" + location.hostname + '/platform/web/v1/auth/oauth2/authorization/azure';
                location.replace(ms);
            },
            submit() {
                this.$v.$touch();

                if(!this.$v.$invalid) {
                    this.$router.push({name : 'loginPassword', params: {username: this.user.userName },
                      query: { sso: true }, hash: resolveWebclientHash()});
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .login-button {
        width: 100%;
        text-transform: initial;
    }

    .v-card__text {
        padding-bottom: 0 !important;
    }

    .header-image-container {
        height: 75px;
    }
</style>
